export const transfer = {
    head: 'โอนคะแนน',
    title: 'รายละเอียดการโอน TIP Coin',
    title2: 'TIP Coin จะถูกโอนไปยังเบอร์โทรศัพท์มือถือที่ได้ลงทะเบียนไว้',
    title3: 'โดยจะใช้ 1 Coin = 10 พ้อยท์',
    confirm_tranfer: 'ยืนยันการโอนคะแนน',
    confirm_desc: 'ท่านต้องการจะโอนคะแนน เป็นจำนวนทั้งหมด ',
    text_point: ' คะแนน',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    transfer_success: 'โอนคะแนนสำเร็จ',
    transfer_success1: 'ทำการโอนคะแนนเรียบร้อย',
    transfer_success2: 'กรุณาเช็คพอยท์ของคุณได้ที่เว็บไซต์ TipSociety',


    contactNumber:{
        name: 'กรุณากรอกเบอร์โทรศัพท์มือถือที่ต้องการโอน TIP Coin',
        placeholder: 'กรุณากรอกเบอร์โทรศัพท์มือถือที่ต้องการโอน TIP Coin',
        required: 'กรุณากรอกเบอร์โทรศัพท์มือถือที่ต้องการโอน TIP Coin',
        too_short: '',
        invalid: '',
    },
    point:{
        name: 'จำนวน TIP Coin ที่ต้องการโอน',
        placeholder: 'จำนวน TIP Coin ที่ต้องการโอน',
        required: 'จำนวน TIP Coin ที่ต้องการโอน',
        too_short: '',
        invalid: '',
    }
}
